import { Fragment, useState, useRef } from 'react';
import { useTick } from '@pixi/react';
import { animationService } from '../../services/AnimationService';
import EntityDisplay from './EntityElements/EntityDisplay';
import { tileWidth, tileHeight } from '../../data/tileset.config';

export const SpellAnimationsRenderer = () => {
  const [, setRenderTick] = useState(0);
  const previousAnimationIds = useRef<Set<string>>(new Set());

  useTick(() => {
    const currentAnimations = animationService.getSpellAnimations();
    const currentIds = new Set(currentAnimations.map((a) => a.id));

    const hasChanged =
      currentIds.size !== previousAnimationIds.current.size ||
      Array.from(currentIds).some(
        (id) => !previousAnimationIds.current.has(id),
      );

    if (hasChanged) {
      previousAnimationIds.current = currentIds;
      setRenderTick((prev) => prev + 1);
    }
  });

  const animations = animationService.getSpellAnimations();

  return (
    <>
      {animations.map((animation) =>
        animation.layers ? (
          <Fragment key={animation.id}>
            {animation.layers.map((layer, i) => (
              <EntityDisplay
                key={`${animation.id}-${i}`}
                clip={{ ...layer, phaseDuration: animation.duration }}
                position={{
                  x: animation.x * tileWidth,
                  y: animation.y * tileHeight,
                }}
                zIndex={layer.zIndex ?? 15}
              />
            ))}
          </Fragment>
        ) : (
          <EntityDisplay
            key={animation.id}
            clip={{
              spriteName: animation.spriteName,
              direction: animation.direction,
              width: animation.width,
              height: animation.height,
              anchor: animation.anchor,
              rotation: animation.rotation,
              phaseDuration: animation.duration,
              animationSpeed: animation.animationSpeed,
              loop: animation.isLooping ?? true,
              parallaxDepth: animation.parallaxDepth,
            }}
            position={{
              x: animation.x * tileWidth,
              y: animation.y * tileHeight,
            }}
            name={animation.id}
            zIndex={15}
          />
        ),
      )}
    </>
  );
};
